import { getOr } from 'lodash/fp';

type EmptyArray = Array<never>;

export const getOrEmptyArray = getOr<EmptyArray>([]);
